<div class="coverage-section">
  <div class="coverage-content">
    <!-- Main Layout: Two Columns -->
    <div class="main-layout" fxLayout="row" fxLayout.xs="column" fxLayoutGap="40px" fxLayoutAlign="start start">
      <!-- Left Column: Policy Information -->
      <div class="policy-info-section" fxFlex="50" fxFlex.xs="100">
        <div class="info-header">
          <h2>Policy Information</h2>
        </div>

        <div class="info-content" fxLayout="column" fxLayoutGap="24px">
          <div class="info-item" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="16px">
            <div class="info-label">Policy Holder:</div>
            <div class="info-value">{{ policy.holderName }}</div>
          </div>

          <div class="info-item" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="16px">
            <div class="info-label">Insured Address:</div>
            <div class="info-value">{{ policy.address }}</div>
          </div>

          <div class="info-item" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="16px">
            <div class="info-label">Effective Date:</div>
            <div class="info-value">{{ policy.effectiveDate }}</div>
          </div>

          <div class="info-item" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="16px">
            <div class="info-label">Expiration Date:</div>
            <div class="info-value">{{ policy.expirationDate }}</div>
          </div>
        </div>
      </div>

      <!-- Right Column: Coverage Limits & Additional Interest -->
      <div class="coverage-limits-section" fxFlex="50" fxFlex.xs="100">
        <div class="section-header">
          <h2>Coverage Limits & Additional Interest</h2>
        </div>

        <!-- Coverage Cards Grid -->
        <div
          class="coverage-grid"
          fxLayout="row wrap"
          fxLayout.xs="column"
          fxLayoutGap="16px"
          fxLayoutAlign="start stretch"
        >
          <div class="coverage-card" *ngFor="let coverage of policy.coverages" fxFlex="40" fxFlex.xs="100">
            <div class="card-content" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="16px">
              <!-- Icon -->
              <div class="coverage-icon">
                <ng-container [ngSwitch]="coverage.icon">
                  <mat-icon *ngSwitchCase="'home'">home</mat-icon>
                  <mat-icon *ngSwitchCase="'liability'">gavel</mat-icon>
                  <mat-icon *ngSwitchCase="'medical'">medical_services</mat-icon>
                  <mat-icon *ngSwitchCase="'umbrella'">umbrella</mat-icon>
                  <mat-icon *ngSwitchDefault>help_outline</mat-icon>
                </ng-container>
              </div>

              <!-- Coverage Info -->
              <div class="coverage-info" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="8px">
                <h3>{{ coverage.type }}</h3>
                <p class="amount">{{ coverage.amount | currency : "USD" : "symbol" : "1.0-0" }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Additional Interest Section -->
        <div class="additional-interest-section" >
          <div
            class="interest-card"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="16px"
          >
            <!-- Location Icon -->
            <div class="location-icon">
              <mat-icon color="warn">location_on</mat-icon>
            </div>

            <!-- Interest Info -->
            <div class="interest-info" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="4px">
              <!-- <h4>{{ interest.name }}</h4> -->
              <p>{{ policy.address }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
